import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import styled from 'styled-components';

const WarningText = () => {
  return (
    <Wrapper>
      <h4>멤버십 구독 유의사항</h4>
      <ul>
        <li>
          멤버십은 최초 구매 후 결제 기간 동안 이용 가능합니다.결제금액은 부가세(VAT)가포함된
          가격입니다.
        </li>
        <li>등록하신 결제 수단으로 정기 결제일에 멤버십 이용 금액이 자동으로 결제됩니다.</li>
        <li>
          자동 결제 진행 중 서비스 사용 해지를 원하시는 경우 ‘마이페이지&gt; 멤버십관리’ 메뉴에서
          자동결제 해지를 통해 서비스 이용을 중단할 수 있습니다.
        </li>
        <li>멤버십티켓의 환불은 &lt;서비스이용표준약관&gt;의 기준에 맞춰 가능합니다.</li>
      </ul>
    </Wrapper>
  );
};

export default WarningText;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${color.opacityBlack01};

  h4 {
    color: ${color.black2};
    ${font.body_medium};
  }

  li {
    ${font.caption1_regular};
    color: ${color.gray700};

    &::before {
      content: '•';
      margin-inline-end: 1ch;
      color: ${color.gray700};
    }
  }
`;
